import { render, staticRenderFns } from "./pc-checkbox-group.vue?vue&type=template&id=62dfc448&scoped=true"
import script from "./pc-checkbox-group.vue?vue&type=script&lang=ts"
export * from "./pc-checkbox-group.vue?vue&type=script&lang=ts"
import style0 from "./pc-checkbox-group.vue?vue&type=style&index=0&id=62dfc448&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dfc448",
  null
  
)

export default component.exports